interface RefurbishedNewTagUserData {
    refurbishedVisitedAt?: string | null;
}

export const shouldShowRefurbishedNewTag = (
    userData?: RefurbishedNewTagUserData | null,
): boolean => {
    return !userData?.refurbishedVisitedAt;
};
